import React from 'react';
export const Coupon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21 10.75h.75V7c0-2.418-1.332-3.75-3.75-3.75H6C3.582 3.25 2.25 4.582 2.25 7v3.75H3c.689 0 1.25.561 1.25 1.25S3.689 13.25 3 13.25h-.75V17c0 2.418 1.332 3.75 3.75 3.75h12c2.418 0 3.75-1.332 3.75-3.75v-3.75H21c-.689 0-1.25-.561-1.25-1.25s.561-1.25 1.25-1.25Zm-.75 3.896V17c0 1.577-.673 2.25-2.25 2.25h-2.25V16.5a.75.75 0 0 0-1.5 0v2.75H6c-1.577 0-2.25-.673-2.25-2.25v-2.354a2.754 2.754 0 0 0 2-2.646 2.754 2.754 0 0 0-2-2.646V7c0-1.577.673-2.25 2.25-2.25h8.25V7.5a.75.75 0 0 0 1.5 0V4.75H18c1.577 0 2.25.673 2.25 2.25v2.354a2.754 2.754 0 0 0-2 2.646c0 1.257.847 2.319 2 2.646Zm-4.5-3.896v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0Z"
      />
    </svg>
  );
};
